(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["halloween-overlay"] && !Shopify.designMode) return;
  try {
    // Product pages: fade the moon and bats out once the description section comes into view.
  (() => {
    const start = () => {
      const sky = document.querySelector('.bintel-halloween-sky--product');
      const target = document.querySelector('#MainContent > .section-product-details');
      if (!sky || !target || !('IntersectionObserver' in window)) return;

      new IntersectionObserver(([entry]) => {
        sky.classList.toggle('is-dimmed', entry.isIntersecting || entry.boundingClientRect.top < 0);
      }, { rootMargin: '0px 0px -35% 0px' }).observe(target);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();

  (() => {
    const init = () => {
      const decorations = document.querySelector('[data-bintel-halloween-header]');
      if (!decorations) return;

      const findHeader = () => document.querySelector('.section-header #x-header') || document.getElementById('x-header');
      let frame = 0;

      // Keeps a reference to the node so it survives the header section being re-rendered.
      const mount = () => {
        frame = 0;
        const header = findHeader();

        if (header) {
          if (decorations.parentElement !== header) header.append(decorations);
          decorations.classList.add('is-mounted');
          return;
        }

        if (!decorations.isConnected) document.body.prepend(decorations);
        decorations.classList.remove('is-mounted');
      };

      const schedule = () => {
        if (!frame) frame = requestAnimationFrame(mount);
      };

      mount();
      document.addEventListener('shopify:section:load', schedule);
      new MutationObserver(() => {
        if (!decorations.isConnected || decorations.parentElement !== findHeader()) schedule();
      }).observe(document.body, { childList: true, subtree: true });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
